import styled from 'styled-components';
import { Switch } from 'antd';

export default styled(Switch)`

    .ant-switch-checked {
        background: #d3d3d3;
    }
`